// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Database } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconDatabase(props: any) {
    return <IconBase icon={Database} {...props} />
  }

  export default IconDatabase
  